// Errors in the browser go to Sentry, in production only: the page carries
// the project's address (a DSN is public by design) when there's one, the
// build and the user's id; no personal data, no tracing, no replays
// (https://docs.sentry.io/platforms/javascript/guides/react/)
import * as Sentry from "@sentry/react"

const meta = (name: string) => document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content || undefined

export function installSentry() {
  const dsn = meta("sentry-dsn")
  if (!dsn) return
  Sentry.init({ dsn, release: meta("sentry-release"), sendDefaultPii: false })
  const user = meta("sentry-user")
  if (user) Sentry.setUser({ id: user })
}
